import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { getEventChipClassName } from "../../utils/calendar/eventStatusStyles";
import { openAppPathInNewTab } from "../../views/dashboard/dashboardHelpers";

function DetailField({ label, value }) {
  return (
    <div>
      <dt className="text-sm font-medium text-gray-500">{label}</dt>
      <dd className="mt-1 text-sm text-gray-900">{value || "—"}</dd>
    </div>
  );
}

export default function OrdersCalendarEventPanel(props) {
  const { event, setOpen } = props;

  if (!event) {
    return null;
  }

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between gap-4">
            <div>
              <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                Order
              </Dialog.Title>
              <p className="mt-1 text-sm text-gray-600">{event.customer}</p>
            </div>
            <button
              type="button"
              className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              onClick={() => setOpen({ childComponent: null, open: false })}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>

        <div className="mt-6 px-4 sm:px-6">
          <div className="mb-4 flex flex-wrap items-center gap-2">
            <span
              className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold ${getEventChipClassName(event)}`}
            >
              {event.status?.label ?? "Unknown"}
            </span>
            {event.is_overdue ? (
              <span className="inline-flex rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-semibold text-red-800">
                Overdue
              </span>
            ) : null}
          </div>

          <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <DetailField label="PO number" value={event.po_number} />
            <DetailField label="Customer ID" value={event.customer_id} />
            <DetailField label="Expected date" value={event.expected_date} />
            <DetailField label="Time" value={event.time} />
            <DetailField label="Order date" value={event.order_date} />
            <DetailField label="Order ID" value={event.id} />
            <DetailField label="Title" value={event.title} />
          </dl>
        </div>
      </div>

      <div className="flex flex-shrink-0 justify-end gap-3 px-4 py-4 sm:px-6">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-gray-300 ring-inset hover:bg-gray-50"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Close
        </button>
        <button
          type="button"
          className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => openAppPathInNewTab(`/orders/${event.id}`)}
        >
          Open full details
        </button>
      </div>
    </div>
  );
}
